"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import { IllustratedMessage } from '../../../IllustratedMessage/IllustratedMessage.mjs';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconSearch } from '../../../Icon/components/icons/IconSearch.mjs';
import { Heading } from '../../../Heading/Heading.mjs';
import { Text } from '../../../Text/Text.mjs';
import locales from '../../../../../../_virtual/_.locale.json@8d5024994f97657f895a4e2a188d2d8a.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import styles from '../../components/Items/Items.module.scss.mjs';

const EmptyView = () => {
  const stringFormatter = useLocalizedStringFormatter(locales);
  return /* @__PURE__ */ jsxs(IllustratedMessage, { className: styles.emptyView, children: [
    /* @__PURE__ */ jsx(IconSearch, {}),
    /* @__PURE__ */ jsx(Heading, { children: stringFormatter.format("list.noResult.heading") }),
    /* @__PURE__ */ jsx(Text, { children: stringFormatter.format("list.noResult.text") })
  ] });
};

export { EmptyView };
//# sourceMappingURL=EmptyView.mjs.map
